/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Aicostscalls2Inputs */

const en_aicostscalls2 = /** @type {(inputs: Aicostscalls2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} calls`)
};

const de_aicostscalls2 = /** @type {(inputs: Aicostscalls2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Aufrufe`)
};

/**
* | output |
* | --- |
* | "{count} calls" |
*
* @param {Aicostscalls2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostscalls2 = /** @type {((inputs: Aicostscalls2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostscalls2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostscalls2(inputs)
	return de_aicostscalls2(inputs)
});
export { aicostscalls2 as "aiCostsCalls" }